import { capitalizeFirstLetter } from '@/helpers';
import { formatTrialEndDate, isShopMidTrial } from '@/pages/Plan/config';
import { useGetUserPlanQuery } from '@/redux/api/api.caller';
import { Banner, Box, Text } from '@shopify/polaris';
import { memo } from 'react';

const TrialBanner = () => {
  const { data: userPlanData } = useGetUserPlanQuery({});
  const billingSummary = userPlanData?.data?.billingSummary;
  const trialInfo = userPlanData?.data?.trialInfo;

  if (!billingSummary || !isShopMidTrial(userPlanData?.data)) return null;

  const { daysLeft, endsOn } = trialInfo!;

  return (
    <Box paddingBlockEnd="400">
      <Banner tone="info" title={`You're on a free trial — ${daysLeft} ${daysLeft === 1 ? 'day' : 'days'} left`}>
        <Text as="p">
          Your{' '}
          <Text as="span" fontWeight="semibold">
            {capitalizeFirstLetter(billingSummary.displayPlan)}
          </Text>{' '}
          plan is free until{' '}
          <Text as="span" fontWeight="semibold">
            {formatTrialEndDate(endsOn)}
          </Text>
          . You'll be charged{' '}
          <Text as="span" fontWeight="semibold">
            ${Number(billingSummary.price)}
          </Text>{' '}
          on that date unless you cancel or change plan before then.
        </Text>
      </Banner>
    </Box>
  );
};

export default memo(TrialBanner);
